var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"},style:({ margin: _vm.margin })},[_c('a',{staticStyle:{"display":"inline-block","padding":"8px 22px","min-width":"110px","vertical-align":"middle","text-align":"center","text-decoration":"none","line-height":"1.5","font-size":"16px","font-weight":"600"},style:({
      backgroundColor: _vm.bgColor,
      color: _vm.color,
      borderRadius: _vm.borderRadius,
    }),attrs:{"href":_vm.href,"target":"_blank","download":_vm.isDownloadHref}},[_vm._v(" "+_vm._s(_vm.label.toUpperCase())+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }